<script>
import { cleanName } from "../../../../../../../services/helpers";

export default {
  name: "NameComponent",
  props: {
    name: {
      type: Object,
      required: true
    },
    searchSubmitHandler: {
      type: Function,
      required: true
    }
  },
  setup(props) {

    const onKeyUp = () => {
      props.name.value = cleanName(props.name.value);
    }

    return {
      onKeyUp
    }
  }
}
</script>

<template>
  <div class="row">
    <div class="col-sm-12">
      <div class="form-group">
        <label>ФИО наследодателя (умершего)</label>
        <dadata-suggestions
          v-model="name.value"
          type="NAME"
          class="form-control"
          @keyup="onKeyUp"
          @change="searchSubmitHandler()"
        />
        <p class="error" v-if="name.hasError">{{ name.errorText }}</p>
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>
